import { useEffect } from "react";

const BADGE_ID = "emergent-badge";

/**
 * Emergent's platform `emergent-main.js` injects the "Made with Emergent"
 * badge at runtime with `display: inline-flex !important` inline, which
 * beats any stylesheet rule. This hook watches the DOM and removes the
 * badge whenever it's added.
 */
export function useHideEmergentBadge() {
  useEffect(() => {
    const kill = () => {
      const el = document.getElementById(BADGE_ID);
      if (el) el.remove();
    };

    kill();

    const observer = new MutationObserver(() => kill());
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety net: also poll briefly in case the script inserts the badge
    // outside of a mutation we catch (shadow DOM, iframe chrome, etc.).
    const iv = setInterval(kill, 1000);

    return () => {
      observer.disconnect();
      clearInterval(iv);
    };
  }, []);
}
